import{
   authTypes
    } from '../actionTypes/authTypes';
const INITIAL_STATE = {
    userDetails: [],
    isAuthenticated: false,
    isLoginSuccess: false,
    isLoginFailure: false,
    isRegisteredSuccess: false,
    isRegisteredFailure: false,
    isLoading: false,
    isToken: null,
    isLogout: false,
}
    
// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case authTypes.LOADER: 
            return {
                ...state,
                isLoading: action.isLoading
            }
        
        case authTypes.LOGIN_DETAILS: 
            return {
                ...state,
                userDetails: action.userDetails,
                isLoading: true,
                isLoginFailure: false,
                isLoginSuccess: false,
                isAuthenticated: false
            }
        
        case authTypes.LOGIN_FAILURE: 
            return {
                ...state,
                isLoginFailure: action.isLoginFailure,
                isLoading: false,
                isAuthenticated: false
            }
        
        case authTypes.LOGIN_SUCCESS: 
            return {
                ...state,
                isLoginSuccess: action.isLoginSuccess,
                isLoading: false,
                isAuthenticated: true,
                isToken: action.isToken
            }
        case authTypes.REGISTER_DETAILS: 
            return {
                ...state,
                userDetails: action.userDetails,
                isLoading: true,
                isRegisteredSuccess: false,
                isRegisteredFailure: false,
                isAuthenticated: false
            }
        case authTypes.REGISTER_FAILURE: 
            return {
                ...state,
                isRegisteredFailure: action.isRegisteredFailure,
                isLoading: false,
                isAuthenticated: false
            }
        case authTypes.REGISTER_SUCCESS: 
            return {
                ...state,
                isRegisteredSuccess: action.isRegisteredSuccess,
                isLoading: false,
            }
        case authTypes.LOGOUT: 
            return {
                isLogout: action.isLogout,
                isLoginSuccess: false,
                isAuthenticated: false,
                isToken: null
            }
        default: return state
    }
}